import ItemVariantsFields from './ItemVariantsFields'
import {onClickBtnItemVariant} from 'actions/library/item'
import {connect} from 'react-redux'
import {getFormValues} from 'redux-form'

class ItemVariantsFieldArray extends React.Component {
  render () {
    const {fields} = this.props
    return (<div className='row'>
      {fields.map((member, index) => (<ItemVariantsFields fields={fields} member={member} />))}
      <div className='form-group col-sm-12'>
        <button onClick={this._onClickBtnItemVariant} className='btn btn-primary btn-block no-border-radius-top'>{this._buttonLabel()}</button>
      </div>
    </div>)
  }

  _onClickBtnItemVariant = (e) => {
    const {dispatch, item} = this.props
    dispatch(onClickBtnItemVariant(item))
    e.stopPropagation()
    e.preventDefault()
  }

  _buttonLabel = () => {
    const {fields} = this.props
    if (fields.length > 1) {
      return 'Manage Variant'
    } else {
      return 'Add Variant'
    }
  }
}

function mapStateToProps (state) {
  return {
    item: getFormValues('item')(state)
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(ItemVariantsFieldArray)



// WEBPACK FOOTER //
// ./app/pages/Library/Item/ItemDetail/ItemForm/ItemVariant/ItemVariantsFieldArray/ItemVariantsFieldArray.js